"use client";

import { RetrievedPartner } from '@/lib/sanity/responseTypes';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import PartnerMapMarker from './PartnerMapMarker';

interface PartnerMapProps {
  partners: RetrievedPartner[];
}

export default function PartnerMap(props: PartnerMapProps) {

  let computedCenter: { lat: number, lng: number };

  let latMin = Number.MAX_VALUE, latMax = Number.MIN_VALUE, lngMin = Number.MAX_VALUE, lngMax = Number.MIN_VALUE;

  for (let p of props.partners) {
    if (!(p.geolocation && typeof p.geolocation.latitude === 'number' && typeof p.geolocation.longitude === 'number')) {
      continue;
    }

    latMin = Math.min(latMin, p.geolocation.latitude);
    latMax = Math.max(latMax, p.geolocation.latitude);
    lngMin = Math.min(lngMin, p.geolocation.longitude);
    lngMax = Math.max(lngMax, p.geolocation.longitude);
  }

  computedCenter = { lat: (latMin + latMax) / 2, lng: (lngMin + lngMax) / 2 };

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GMAPS_API_KEY || ""}>
      <Map defaultCenter={computedCenter} defaultZoom={5} mapId={process.env.NEXT_PUBLIC_GMAPS_MAP_ID} renderingType='VECTOR' mapTypeControl={false}>
        {props.partners.map((p, i) => {
          if (!(p.geolocation && typeof p.geolocation.latitude === 'number' && typeof p.geolocation.longitude === 'number')) {
            return null;
          }

          return (
            <PartnerMapMarker key={`gmap-marker-${i}`} color={"red"} partner={p} position={{ lat: p.geolocation.latitude, lng: p.geolocation.longitude }} />
          );
        })}
      </Map>
    </APIProvider>
  );
}
